import { AiOutlineArrowLeft } from 'react-icons/ai';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import LoginForm from './LoginForm';
import * as duckActions from './duck';

import { ActionButton, IntlMessage } from '$HVUI';

const Login = props => {
    if (props.loggedIn) {
        return <Redirect to="consents" push />;
    }
    return (
        <div>
            <div
                style={{
                    position: 'absolute',
                    left: '16px',
                    top: '16px'
                }}
            >
                <ActionButton
                    id="back-button"
                    icon={AiOutlineArrowLeft}
                    style={{ height: '35px', width: '35px' }}
                    text="Back"
                    onClick={() => {
                        window.location.href = 'has-account';
                    }}
                />
            </div>
            <h1 style={{ marginTop: '32px' }}>
                <IntlMessage
                    id="sign-in.sign-in-to-your-healthvana-account"
                    defaultMessage="Sign in to your Healthvana account"
                />
            </h1>
            <LoginForm onSubmit={props.logIn} />
        </div>
    );
};

export const mapStateToProps = (state, ownProps) => {
    return Object.assign(
        {},
        {
            loggedIn: state.introduction.loggedIn
        },
        ownProps
    );
};

export default connect(mapStateToProps, duckActions)(Login);
